import gql from "graphql-tag";

/* Account Mutations */
export const CREATE_ACCOUNT = gql`
  mutation(
    $accountData: AccountSignupData!
    $authProvider: AuthProviderSignupData!
  ) {
    createAccount(accountData: $accountData, authProvider: $authProvider) {
      name
      email
      phone
      accountType
      experiments {
        id
      }
    }
  }
`;

/* Account Queries */
export const CURRENT_ACCOUNT = gql`
  query {
    currentAccount {
      name
      email
      phone
      accountType
      experiments {
        id
        name
        date
        filename
        resultsImage
        data {
          x
          y
          z
        }
        intervals
      }
    }
  }
`;

export const SIGNIN_ACCOUNT = gql`
  mutation($email: String!, $password: String!) {
    signinAccount(credentials: { email: $email, password: $password }) {
      name
      email
      phone
      accountType
      experiments {
        id
        name
        date
        filename
        resultsImage
        data {
          x
          y
          z
        }
        intervals
      }
    }
  }
`;

export const SIGNOUT_ACCOUNT = gql`
  mutation {
    logoutAccount {
      status
    }
  }
`;

export const CREATE_EXPERIMENT = gql`
  mutation($experimentData: ExperimentInput!) {
    createExperiment(experimentData: $experimentData) {
      id
      name
      date
      filename
      resultsImage
      data {
        x
        y
        z
      }
      intervals
    }
  }
`;

export const UPDATE_EXPERIMENT = gql`
  mutation($id: ID!, $experimentData: ExperimentInput!) {
    updateExperiment(id: $id, experimentData: $experimentData) {
      id
      name
      date
      filename
      resultsImage
      data {
        x
        y
        z
      }
      intervals
    }
  }
`;

export const DELETE_EXPERIMENT = gql`
  mutation($id: ID!) {
    deleteExperiment(id: $id)
  }
`;
